import React from 'react';
import { Spin } from 'antd';

export const LCSpin = () => <Spin />;